import { useTranslation } from 'react-i18next';
import useUser from 'src/hook/data/useUser';
import { useIFrameModal } from 'src/hook/modal/useIFrameModal';
import { GetRazorSiteUrl, ImageLocation } from 'src/utils/URLUtils';
import styles from './Financial.module.scss';

const Financial = () => {
    const { t } = useTranslation();
    const { open } = useIFrameModal();
    const { userInfo } = useUser();

    const handleLearnMore = () => {
        open(GetRazorSiteUrl('pro/charity',
            userInfo?.Token));
    }

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h2 className={styles.title}>{t('Financial Aid')}</h2>
                <p className={styles.description}>
                    {t('For those in serious financial hardship, we offer a discounted charitable plan.')}
                </p>
                <div className={styles.illustration}>
                    <img
                        src={ImageLocation('Lexi/Holding-Gift.png')}
                        alt={t('Gift box illustration')}
                        width={140}
                        height={140}
                    />
                </div>
                <button
                    onClick={handleLearnMore}
                    className={styles.learnMore + ' secondaryButton'}>
                    {t('Learn More')}
                </button>
            </div>
        </div>
    );
};

export default Financial;
